var _circle, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5194 79.3018C26.1944 78.1052 20.3959 75.4195 15.5023 71.623C17.176 65.3409 24.3666 51.4114 32.9956 53.8517C39.7955 55.7746 35.3961 74.8206 32.5194 79.3018Z",
    fill: "#9574FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0504 74.6778C22.6828 60.3115 28.4125 47.913 39.6667 47.913C49.9491 47.913 55.8343 60.6539 58.9258 75.2482C53.2913 78.2799 46.8465 80 40 80C32.735 80 25.9224 78.0632 20.0504 74.6778Z",
    fill: "#9E80FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6964 77.943C48.9013 73.9413 40.4795 58.1229 48.2051 52.4451C53.8581 48.2905 66.4206 63.1786 68.3524 68.216C64.0099 72.5793 58.6669 75.946 52.6964 77.943Z",
    fill: "#A78CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7778 50.8823C43.7778 52.914 35.5556 53.0703 35.5556 50.8823V38.5361H43.7778V50.8823Z",
    fill: "#FFCBAD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.532,
    cy: 31.5816,
    rx: 8.14316,
    ry: 14.2997,
    fill: "#FFD8C1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1218,
    cy: 33.6132,
    rx: 2.13462,
    ry: 2.10979,
    fill: "#FFD8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6784 45.0961C79.8906 43.4273 80 41.7264 80 40C80 30.6883 76.8182 22.1198 71.4826 15.3224C68.9888 15.5774 66.6502 16.4704 64.2751 17.3774C61.3582 18.4912 58.3863 19.6261 55.0043 19.6261C52.8315 19.6261 50.6919 18.4458 48.3728 17.1663C45.6288 15.6525 42.6334 14 39.0342 14C30.4957 14 27.8077 18.5321 27.8077 21.6578C27.8077 24.1583 29.3889 26.9713 29.8632 26.9713C29.8632 26.1899 30.812 23.3769 31.1282 23.0643C31.4444 24.1583 38.0855 31.816 43.9359 31.816V31.8598C44.8265 31.2708 46.0209 31.4257 46.7276 32.2218C47.4343 33.018 47.4343 34.2086 46.7276 35.0047C46.0209 35.8008 44.8265 35.9557 43.9359 35.3667V39.9426H45.5171C46.4346 39.9426 47.1316 39.7869 47.9034 39.6146C48.8606 39.4007 49.9329 39.1612 51.6838 39.1612C54.0802 39.1612 56.8918 40.4213 60.0799 41.8502C64.2542 43.7211 69.074 45.8813 74.453 45.8813C76.4083 45.8813 78.1461 45.6041 79.6784 45.0961Z",
    fill: "#DF684E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.8ba2536884b52e4f51ed89edd48c9213.svg";
export { ForwardRef as ReactComponent };